import { Component, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Team from "./pages/Team";
import InvoiceView from "./pages/InvoiceView";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error("App error boundary:", error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-midnight text-white flex items-center justify-center p-8 text-center">
          <div>
            <h1 className="font-display text-3xl">Something fogged up.</h1>
            <p className="text-mist mt-3">Refresh the page — or call 630-909-3759 to book.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/team" element={<Team />} />
          <Route path="/invoice/:ref" element={<InvoiceView />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors closeButton />
    </ErrorBoundary>
  );
}

export default App;
